import { render } from "./ProductItem.vue?vue&type=template&id=1900e2cb&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=js"
export * from "./ProductItem.vue?vue&type=script&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=1900e2cb&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1900e2cb"]])

export default __exports__